import $ from 'zepto';
import { onDocumentReady } from '../../main';
// eslint-disable-next-line import/no-useless-path-segments
import Tooltip from '../tooltip/Tooltip';
import { tooltipSelector } from '../../utils/constants/classes';

const $body = $(document.body);
export function initTooltips($context = $body) {
  $context.find(tooltipSelector).each((index, element) => {
    const $tooltip = $(element);
    new Tooltip().init($tooltip, `xvx-tooltip-${index}`);
  });
}

onDocumentReady('Tooltips', () => {
  initTooltips();
});

export default {
  initTooltips,
};
